export const getUsuarioFromSession = (sessionResponse) => (
  sessionResponse?.data?.user
  ?? sessionResponse?.data?.usuario
  ?? sessionResponse?.user
  ?? sessionResponse?.usuario
  ?? sessionResponse
)

export const getApplicationsFromSession = (sessionResponse) => (
  sessionResponse?.data?.applications
  ?? sessionResponse?.applications
  ?? []
)

export const getApplicationCode = (applicationAccess) => (
  applicationAccess?.application?.code
  ?? applicationAccess?.applicationCode
  ?? applicationAccess?.code
  ?? ''
)

export const getApplicationAccess = (sessionResponse, applicationCode) => (
  getApplicationsFromSession(sessionResponse).find((applicationAccess) => (
    String(getApplicationCode(applicationAccess)).toUpperCase()
    === String(applicationCode || '').toUpperCase()
  ))
)

const suiteAdminRoleId = '1'

const getRoleId = (role) => (
  role?.id
  ?? role?.role?.id
  ?? role?.roleId
  ?? ''
)

const hasSuiteAdminRole = (applicationAccess) => (
  (applicationAccess?.roles || []).some((role) => (
    String(getRoleId(role)) === suiteAdminRoleId
  ))
)

export const getAdminApplicationAccess = (sessionResponse) => (
  // El rol global 1 identifica al administrador de la suite; ADMIN se repite en otras apps.
  getApplicationsFromSession(sessionResponse).find(hasSuiteAdminRole)
)

export const getAdminApplicationCode = (sessionResponse) => (
  getApplicationCode(getAdminApplicationAccess(sessionResponse))
)

export const getPermisosAplicacion = (sessionResponse, applicationCode) => (
  getApplicationAccess(sessionResponse, applicationCode)?.permissions || []
)

export const tienePermiso = (sessionResponse, applicationCode, permissionCode) => (
  getPermisosAplicacion(sessionResponse, applicationCode).includes(permissionCode)
)

export const puedeVerPanelAdmin = (sessionResponse) => (
  Boolean(getAdminApplicationAccess(sessionResponse))
)

export const getRutaInicialSesion = (sessionResponse) => (
  puedeVerPanelAdmin(sessionResponse) ? '/admin' : '/'
)
